// eslint-disable-next-line import/prefer-default-export
export const SET_CLIENTS = 'SET_CLIENTS';



// WEBPACK FOOTER //
// ./src/store/modules/clients-mutation-type.js